import { render } from "./detailcards.vue?vue&type=template&id=04431758"
import script from "./detailcards.vue?vue&type=script&lang=js"
export * from "./detailcards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__